import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import Timesheets from '../../../Components/pages/timesheets/Timesheets';
import { getConstants } from '../../../actions/constFromApi';
import classes from './TimesheetsPage.module.scss';

export default function TimesheetsPage() {
  const dispatch = useDispatch();
  const constants = useSelector((state) => state.constFromApi);
  const [searchParams] = useSearchParams();
  const [key, setKey] = useState(1);

  useEffect(() => {
    if (searchParams.has('status') && !searchParams.has('page')) {
      setKey((prev) => prev + 1);
    }
  }, [searchParams]);

  useEffect(() => {
    if (!constants.clients?.length || !constants.worktypes?.length) dispatch(getConstants(true));
  }, [constants.clients?.length, constants.worktypes?.length]);

  return (
    <section className={`${classes.pageContainer}`}>
      <Timesheets key={key} />
    </section>
  );
}
